import { createContext, useCallback, useContext, useSyncExternalStore } from 'react';

/** Which embed plays (one at a time, spec §D.5); the controller owns it and stops it on any navigation. */
export type EmbedControl = { active(): string | null; subscribe(cb: () => void): () => void; activate(id: string | null): void };

export const EmbedContext = createContext<EmbedControl | null>(null);

/** True inside an export rendering (P9): no interface, embeds as their poster, no upload marks. */
export const ExportModeContext = createContext(false);

export function useEmbedActive(id: string): [boolean, (on: boolean) => void] {
  const ctl = useContext(EmbedContext);
  const subscribe = useCallback((cb: () => void) => ctl?.subscribe(cb) ?? (() => undefined), [ctl]);
  const active = useSyncExternalStore(subscribe, () => ctl?.active() === id);
  return [active, (on) => ctl?.activate(on ? id : null)];
}
